import LogDescription from './LogDescription';

export default LogDescription;
